import * as firebase from 'firebase';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBnhjWyQAWxedSEhBMT-8zYMTyElBDUnpU",
  authDomain: "com-surpnorm-senseev.firebaseapp.com",
  databaseURL: "https://com-surpnorm-senseev.firebaseio.com",
  projectId: "com-surpnorm-senseev",
  storageBucket: "com-surpnorm-senseev.appspot.com",
  messagingSenderId: "493628427564"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const auth = firebase.auth();
const messaging = firebase.messaging();
export {
  auth,
  messaging,
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js